<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          :router="router" active-text-color="#002057">
          <el-menu-item v-for="(item, index) in menus" :index="item.index" :key="index">{{ item.name }}</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <li v-for="(item, index) in menus" :key="index">
              <p @click="goToPage(item.index)">{{ item.name }}</p>
              <template v-if="item.children">
                <span v-for="(child, index2) in item.children" :key="index2"
                  @click="goToPage(item.index, child.moveTo)">{{ child.name }}</span>
              </template>
            </li>
            <!-- <li>
              <p>联系我们</p>
              <span>邮箱：{{ email }}</span>
              <span>电话：{{ phone }}</span>
              <span>地址：{{ address }}</span>
              <span></span>
            </li> -->
          </ul>
          <!-- <img src="./assets/img/ercode.png" alt /> -->
        </div>
        <div class="copyright">
          <span>上海神舟汽车节能环保股份有限公司 | 上海神舟精宜汽车制造有限公司 | 上海神舟精宜汽车测控技术有限公司</span>
          <span>{{ address }}&nbsp;&nbsp;&nbsp;服务热线：{{ phone }}&nbsp;&nbsp;&nbsp;Email: {{ email }}</span>
          <span>沪公网安备 31011202002378号 沪ICP备13019320号-1 2024@交大神舟版权所有</span>
        </div>
      </div>
    </el-container>
    <el-backtop :bottom="40" :right="40"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      email: '',
      phone: '',
      address: '',
      menus: [
        {
          name: "首页",
          index: "/",
          children: [
            {
              name: '最新资讯',
              moveTo: 'latestNews',
            },
          ],
        },
        {
          name: "专用车辆与装备",
          index: "/product",
          children: [
            {
              name: '特种车辆',
              moveTo: 1,
            },
            {
              name: '环保设备',
              moveTo: 2,
            },
          ],
        },
        {
          name: "智能化系统",
          index: "/intelligentize-system",
        },
        {
          name: "公司资讯",
          index: "/news",
        },
        {
          name: "招才纳士",
          index: "/invite",
        },
        {
          name: "客户服务",
          index: "/client",
        },
        {
          name: "关于我们",
          index: "/goin",
          children: [
            {
              name: "公司简介",
              moveTo: "summary",
            },
            {
              name: "发展历程",
              moveTo: "course",
            },
            {
              name: "企业文化",
              moveTo: "culture",
            },
            {
              name: "团队风采",
              moveTo: "team",
            },
            {
              name: "公司荣誉",
              moveTo: "honor",
            },

          ]
        },
      ],
    };
  },
  mounted() {
    this.selectIndex();
    this.loadData();
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
    },
    selectIndex() {
      let hash = this.$route.path;
      let end = hash.indexOf('?');
      if (end != -1) {
        hash = hash.substring(0, end);
      }

      // console.log(hash);

      let menu = this.menus.find(item => hash == item.index);

      if (menu) {
        this.defaultActive = hash;
      } else {
        this.defaultActive = null;
      }

      setTimeout(() => {
        this.$nextTick(() => {
          let top = 0;
          let moveTo = this.$route.query.moveTo;
          if (moveTo) {
            let element = document.getElementById(moveTo);

            while (element) {
              top += element.offsetTop;
              element = element.offsetParent;
            }

          }
          // 滚动到指定位置
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        })
      }, 100);
    },
    loadData() {
      this.http
        .get(`/basic/data-dictionary?key=邮箱`)
        .then(response => {
          this.email = response.data.content;
        })
        .catch(function (error) {
          this.$message({ message: response.msg || '系统异常', type: "error" });
        });
      this.http
        .get(`/basic/data-dictionary?key=电话`)
        .then(response => {
          this.phone = response.data.content;
        })
        .catch(function (error) {
          this.$message({ message: response.msg || '系统异常', type: "error" });
        });
      this.http
        .get(`/basic/data-dictionary?key=地址`)
        .then(response => {
          this.address = response.data.content;
        })
        .catch(function (error) {
          this.$message({ message: response.msg || '系统异常', type: "error" });
        });
    },
    goToPage(url, moveTo) {
      if (moveTo) {
        this.$router.push({ path: url, query: { moveTo } });
      } else {
        this.$router.push(url);
      }

      // 路由发生改变事件对象
      let event = new Event("routerChangeEvent");
      // 触发路由发生改变事件
      window.dispatchEvent(event);

      this.selectIndex();
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  // height: 216px;
  overflow: hidden;
  background-color: #002057;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: center;

    .content-nav {
      display: flex;
      justify-content: space-around;
      // text-align: center;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 30px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
          cursor: pointer;
        }

        span {
          font-size: 16px;
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
          cursor: pointer;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }

  .copyright {
    // height: 30px;
    text-align: center;
    margin-bottom: 20px;

    span {
      font-size: 15px;
      color: #fff;
      display: block;
      line-height: 24px;
    }
  }
}
</style>
